angular.module('internal.chargingrequest',[])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state('internal.chargingrequest', {
            url: '/chargingrequest/:context/:contextId/:state', // (context = 'vehicle', contextId=<vehicle id>), (context = 'booking', contextId=<booking id>)
            views: {
                content: {
                    templateUrl: 'js/internal/chargingrequest/chargingrequest.view.html',
                    controller:'ChargingRequestCtrl'
                }
            }
        });
    }]);
